module.exports = __webpack_public_path__ + "static/media/bg.f9798be1.svg";